export const blogList3 = [
  {
    id: 1,
    title: 'Mann Goel',
    category: '',
    subCategory: ['frontend', 'ui/ux', 'design'],
    description:
    'From all these instances, I learnt one thing very much, that was being ‘persistent’ with whatever you desire.',
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'January 05, 2023',
    cover: 'https://miro.medium.com/v2/resize:fit:1100/0*LkwkXdCW-X7_Z99i',
    medium: 'https://medium.com/@swgiitkgp/adieu-kgp-mann-goel-abf81380c9b5'
  },
  {
    id: 2,
    title: 'Shivam Kumar Jha',
    category: '',
    subCategory: ['frontend', 'ui/ux', 'design'],
    description:'I felt at the top of the world, knowing I could learn programming and computers at the premier institute.',
    authorName: 'John Doe',
    authorAvatar: '/assets/images/author.jpg',
    createdAt: 'December 15, 2022',
    cover: 'https://miro.medium.com/max/1100/0*NhNiEvcBGBFShPBt',
    medium: 'https://medium.com/@swgiitkgp/adieu-kgp-shivam-kumar-jha-c0211f8b0838'
  },
    {
      id: 3,
      title: 'Atal Ashutosh',
      category: '',
      subCategory: ['frontend', 'ui/ux', 'design'],
      description:
      'There are no excuses. We can all work on ourselves and create a better version of ourselves. Its all about our priority.',
      authorName: 'John Doe',
      authorAvatar: '/assets/images/author.jpg',
      createdAt: 'December 04, 2022',
      cover: 'https://miro.medium.com/max/1100/0*8PMOQLTjgNH-bm8s',
      medium: 'https://medium.com/@swgiitkgp/adieu-kgp-atal-ashutosh-agarwal-1174fb556343'
    },
    
  ];
  